export const normalizeDescriptionItems = (description) => {
  if (description == null || description === '') return [];

  const items = Array.isArray(description) ? description : [description];

  return items
    .map((item) => (item == null ? '' : String(item).trim()))
    .filter(Boolean);
};
export const DESCRIPTION_COMPACT_THRESHOLD = 130;

export const getDescriptionCharacterCount = (description) => {
  if (!description) return 0;

  if (Array.isArray(description)) {
    return description.reduce((total, item) => total + String(item).length, 0);
  }

  return String(description).length;
};

export const isDescriptionLong = (
  description,
  threshold = DESCRIPTION_COMPACT_THRESHOLD
) => getDescriptionCharacterCount(description) > threshold;
